(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('LawsPertainingToWomenController', LawsPertainingToWomenController);

    LawsPertainingToWomenController.$inject = ['$scope'];

    function LawsPertainingToWomenController($scope) {
        var vm = this;

    }
})();
